import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import AppShell, { SettingsGroup } from '../components/layout/AppShell';
import DesignSystem from '../designSystem';
import { MAP_PROVIDER_KEY } from '../utils/openInMaps';
import { useT } from '../i18n/useT';

/** PARITY(ChoseMapFragment): apple = platform default (maps.apple.com); google = Google Maps. Android index 0/1 + geo vs Google package — see proof/maps-platform-split.md */
export default function MapsSettingsPage() {
  const t = useT();
  const [value, setValue] = useState('apple');

  useEffect(() => {
    setValue(localStorage.getItem(MAP_PROVIDER_KEY) || 'apple');
  }, []);

  const onChange = (v: string) => {
    setValue(v);
    localStorage.setItem(MAP_PROVIDER_KEY, v);
  };

  return (
    <AppShell title={t('settingsMaps')} showBackButton maxWidth="sm" showCompanion={false}>
      <Typography sx={{ mb: 2, fontSize: 14, color: DesignSystem.colors.textSecondary }}>
        {t('mapsSettingsIntro')}
      </Typography>
      <SettingsGroup>
        <Box sx={{ px: 2.5, py: 1.5 }}>
          <FormControl>
            <RadioGroup value={value} onChange={(e) => onChange(e.target.value)}>
              <FormControlLabel
                value="apple"
                control={<Radio />}
                label={t('mapsDefaultMaps')}
              />
              <FormControlLabel value="google" control={<Radio />} label={t('mapsGoogle')} />
            </RadioGroup>
          </FormControl>
          <Typography variant="caption" sx={{ display: 'block', mt: 1, color: DesignSystem.colors.textSecondary }}>
            {t('mapsSettingsIntro')}
          </Typography>
        </Box>
      </SettingsGroup>
    </AppShell>
  );
}
